import React, { useEffect, useState } from "react";
import { SelectField } from "@culturehq/components";
import { t } from "app/utils";

const SORT_OPTIONS = [
  { value: "selected", label: t("Selected") },
  { value: "unselected", label: t("Unselected") }
];

const SortBySelected = ({
  value,
  onSelected,
  values,
  setValues,
  setOrderBy = undefined,
  disabled = false
}) => {
  const handleSortBy = value => {
    if (value === "selected") {
      setValues([...values.sort((a, b) => {
        if (a.selected === b.selected) {
          return 0;
        }

        return (a.selected ? -1 : 1);
      })]);
    }

    if (value === "unselected") {
      setValues([...values.sort((a, b) => {
        if (a.selected === b.selected) {
          return 0;
        }

        return (a.selected ? 1 : -1);
      })]);
    }

    if (value === null) {
      setValues([...values.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (b.name < a.name) {
          return 1;
        }

        return 0;
      })]);
    }

    if (setOrderBy) {
      setOrderBy(value);
    }
  };

  return (
    <SelectField
      className="ApproveProfileModal-Sort"
      onChange={onSelected || handleSortBy}
      options={SORT_OPTIONS}
      placeholder={t("Sort by")}
      value={value}
      disabled={disabled}
    />
  );
};

export default SortBySelected;
